/**
 * PWA utility functions
 */

/**
 * Check if the app is running in standalone mode (installed PWA)
 * @returns {boolean}
 */
export function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

/**
 * Check if the device is iOS
 * @returns {boolean}
 */
export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

/**
 * Check if the device is Android
 * @returns {boolean}
 */
export function isAndroid() {
  return /Android/.test(navigator.userAgent);
}

/**
 * Check if the browser supports PWA installation
 * @returns {boolean}
 */
export function supportsPWA() {
  return "serviceWorker" in navigator && "PushManager" in window;
}
